<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb [title]="'MENUITEMS.ATTENDANCE.TEXT' | translate"
                      [items]="[('attendanceAttemptsCatalog.breadcrumb' | translate)]"></app-breadcrumb>
    </div>

    <div class="attendance-attempt-workspace"
         [class.attendance-attempt-workspace--loading]="isLoading">
      <mat-card class="attendance-attempt-panel attendance-attempt-panel--detail"
                [class.attendance-attempt-panel--view]="isViewMode">
        <div class="attendance-attempt-panel__header">
          <div class="attendance-attempt-panel__heading">
            <span class="attendance-attempt-panel__eyebrow">{{ 'attendanceAttemptsCatalog.breadcrumb' | translate }}</span>
            <h3>{{ detailTitle }}</h3>
            <p>{{ detailDescription }}</p>
          </div>
          <div class="attendance-attempt-panel__actions">
            @if (selectedAttempt && isViewMode) {
              <button mat-stroked-button type="button" class="btn-tone-danger" *appCanAccess="deleteAccess" (click)="deleteSelected()">
                <mat-icon>delete_outline</mat-icon>
                {{ 'common.delete' | translate }}
              </button>
              <button mat-stroked-button type="button" class="btn-tone-neutral" (click)="goBackToList()">
                <mat-icon>arrow_back</mat-icon>
                {{ 'common.back' | translate }}
              </button>
            }
            @if (isCreateMode) {
              <button mat-flat-button type="button" class="btn-tone-primary" (click)="save()" [disabled]="isSaving || !canSave">
                <mat-icon>save</mat-icon>
                {{ 'common.create' | translate }}
              </button>
              <button mat-stroked-button type="button" class="btn-tone-neutral" (click)="cancelEdit()" [disabled]="isSaving">
                <mat-icon>arrow_back</mat-icon>
                {{ 'common.cancel' | translate }}
              </button>
            }
          </div>
        </div>

        <div class="attendance-attempt-panel__body">
          @if (isCreateMode) {
            <div class="attendance-attempt-editor">
              <div class="card attendance-attempt-editor__section mb-0">
                <div class="card-body">
                  <div class="attendance-attempt-section-heading">
                    <div class="attendance-attempt-section-heading__title">
                      <h4>{{ 'attendanceAttemptsCatalog.sections.general' | translate }}</h4>
                      <span class="attendance-attempt-required-badge">{{ 'common.requiredLabel' | translate }}</span>
                    </div>
                    <p>{{ 'attendanceAttemptsCatalog.sections.generalDescription' | translate }}</p>
                  </div>

                  <div class="attendance-attempt-editor__form-grid">
                    <mat-form-field subscriptSizing="dynamic" appearance="outline" class="attendance-attempt-editor__field attendance-attempt-editor__field--full">
                      <mat-label>{{ 'attendanceAttemptsCatalog.fields.employee' | translate }}</mat-label>
                      <mat-select [(ngModel)]="form.employeeId" [disabled]="isSaving">
                        @for (employee of employees; track employee.employeeId) {
                          <mat-option [value]="employee.employeeId">{{ employee.fullName || employee.employeeNumber }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field subscriptSizing="dynamic" appearance="outline" class="attendance-attempt-editor__field">
                      <mat-label>{{ 'attendanceAttemptsCatalog.fields.source' | translate }}</mat-label>
                      <mat-select [(ngModel)]="form.source" [disabled]="isSaving">
                        @for (source of sourceOptions; track source) {
                          <mat-option [value]="source">{{ ('attendanceAttemptsCatalog.sources.' + source) | translate }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field subscriptSizing="dynamic" appearance="outline" class="attendance-attempt-editor__field">
                      <mat-label>{{ 'attendanceAttemptsCatalog.fields.eventType' | translate }}</mat-label>
                      <mat-select [(ngModel)]="form.eventType" [disabled]="isSaving">
                        @for (type of eventTypeOptions; track type) {
                          <mat-option [value]="type">{{ ('attendanceAttemptsCatalog.eventTypes.' + type) | translate }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>

                    <app-date-time-picker-field class="attendance-attempt-editor__field"
                                                [label]="'attendanceAttemptsCatalog.fields.eventAt' | translate"
                                                [value]="form.eventAt"
                                                mode="datetime"
                                                [disabled]="isSaving"
                                                (valueChange)="form.eventAt = $event">
                    </app-date-time-picker-field>

                    <mat-form-field subscriptSizing="dynamic" appearance="outline" class="attendance-attempt-editor__field">
                      <mat-label>{{ 'attendanceAttemptsCatalog.fields.timezone' | translate }}</mat-label>
                      <input matInput [(ngModel)]="form.timezone" [disabled]="isSaving">
                    </mat-form-field>

                    <mat-form-field subscriptSizing="dynamic" appearance="outline" class="attendance-attempt-editor__field attendance-attempt-editor__field--full">
                      <mat-label>{{ 'attendanceAttemptsCatalog.fields.reasonCode' | translate }}</mat-label>
                      <mat-select [(ngModel)]="form.reasonCode" [disabled]="isSaving">
                        @for (reasonCode of reasonCodeOptions; track reasonCode) {
                          <mat-option [value]="reasonCode">{{ ('attendanceAttemptsCatalog.reasonCodes.' + reasonCode) | translate }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field subscriptSizing="dynamic" appearance="outline" class="attendance-attempt-editor__field">
                      <mat-label>{{ 'attendanceAttemptsCatalog.fields.deviceId' | translate }}</mat-label>
                      <input matInput [(ngModel)]="form.deviceId" [disabled]="isSaving">
                    </mat-form-field>

                    <mat-form-field subscriptSizing="dynamic" appearance="outline" class="attendance-attempt-editor__field">
                      <mat-label>{{ 'attendanceAttemptsCatalog.fields.deviceVersion' | translate }}</mat-label>
                      <input matInput [(ngModel)]="form.deviceVersion" [disabled]="isSaving">
                    </mat-form-field>

                    <mat-form-field subscriptSizing="dynamic" appearance="outline" class="attendance-attempt-editor__field">
                      <mat-label>{{ 'attendanceAttemptsCatalog.fields.lat' | translate }}</mat-label>
                      <input matInput type="number" step="0.000001" [(ngModel)]="form.lat" [disabled]="isSaving">
                    </mat-form-field>

                    <mat-form-field subscriptSizing="dynamic" appearance="outline" class="attendance-attempt-editor__field">
                      <mat-label>{{ 'attendanceAttemptsCatalog.fields.lng' | translate }}</mat-label>
                      <input matInput type="number" step="0.000001" [(ngModel)]="form.lng" [disabled]="isSaving">
                    </mat-form-field>

                    <mat-form-field subscriptSizing="dynamic" appearance="outline" class="attendance-attempt-editor__field">
                      <mat-label>{{ 'attendanceAttemptsCatalog.fields.accuracy' | translate }}</mat-label>
                      <input matInput type="number" step="1" [(ngModel)]="form.accuracy" [disabled]="isSaving">
                    </mat-form-field>

                    <mat-form-field subscriptSizing="dynamic" appearance="outline" class="attendance-attempt-editor__field">
                      <mat-label>{{ 'attendanceAttemptsCatalog.fields.faceValidationStatus' | translate }}</mat-label>
                      <mat-select [(ngModel)]="form.faceValidationStatus" [disabled]="isSaving">
                        <mat-option [value]="''">-</mat-option>
                        @for (faceStatus of faceValidationStatusOptions; track faceStatus) {
                          <mat-option [value]="faceStatus">{{ ('attendanceAttemptsCatalog.faceStatuses.' + faceStatus) | translate }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>

                    @if (!isCreateMode) {
                      <mat-form-field subscriptSizing="dynamic" appearance="outline" class="attendance-attempt-editor__field">
                        <mat-label>{{ 'attendanceAttemptsCatalog.fields.isActive' | translate }}</mat-label>
                        <mat-select [(ngModel)]="form.isActive" [disabled]="isSaving">
                          <mat-option [value]="true">{{ 'common.status.active' | translate }}</mat-option>
                          <mat-option [value]="false">{{ 'common.status.inactive' | translate }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    }

                    <mat-form-field subscriptSizing="dynamic" appearance="outline" class="attendance-attempt-editor__field attendance-attempt-editor__field--full">
                      <mat-label>{{ 'attendanceAttemptsCatalog.fields.rawPayload' | translate }}</mat-label>
                      <textarea matInput rows="8" [(ngModel)]="form.rawPayloadText" [disabled]="isSaving"></textarea>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          } @else if (selectedAttempt; as attempt) {
            <div class="attendance-attempt-detail attendance-attempt-detail--redesigned">
              <section class="attendance-attempt-hero">
                <div class="attendance-attempt-hero__employee">
                  <div class="attendance-attempt-avatar">{{ employeeInitials }}</div>
                  <div><span>{{ 'attendanceAttemptsCatalog.fields.employee' | translate }}</span><strong>{{ attempt.employeeLabel }}</strong><small>#{{ attempt.employeeNumber }}</small></div>
                </div>
                <div class="attendance-attempt-hero__facts">
                  <div class="attendance-attempt-hero-fact"><mat-icon>login</mat-icon><div><span>{{ 'attendanceAttemptsCatalog.fields.eventType' | translate }}</span><strong>{{ attempt.eventTypeLabel }}</strong></div></div>
                  <div class="attendance-attempt-hero-fact"><mat-icon>{{ eventSourceIcon }}</mat-icon><div><span>{{ 'attendanceAttemptsCatalog.fields.source' | translate }}</span><strong>{{ attempt.sourceLabel }}</strong></div></div>
                  <div class="attendance-attempt-hero-fact"><mat-icon>calendar_month</mat-icon><div><span>{{ 'attendanceAttemptsCatalog.fields.eventAt' | translate }}</span><strong>{{ eventDateLabel }}</strong><small>{{ eventTimeLabel }}</small></div></div>
                </div>
                <div class="attendance-attempt-hero__result">
                  <div class="attendance-attempt-warning-icon"><mat-icon>priority_high</mat-icon></div>
                  <div><strong>Intento descartado</strong><span>{{ attempt.reasonCodeLabel }}</span><p>{{ reasonDescription }}</p></div>
                </div>
              </section>

              <div class="attendance-attempt-main-grid">
                <section class="attendance-attempt-card">
                  <div class="attendance-attempt-card-heading"><mat-icon>description</mat-icon><div><h4>Información del intento</h4><p>Datos principales del evento recibido.</p></div></div>
                  <div class="attendance-attempt-detail-list">
                    <div><span>{{ 'attendanceAttemptsCatalog.fields.employeeNumber' | translate }}</span><strong>{{ attempt.employeeNumber }}</strong></div>
                    <div><span>{{ 'attendanceAttemptsCatalog.fields.eventType' | translate }}</span><strong class="attendance-attempt-value-pill">{{ attempt.eventTypeLabel }}</strong></div>
                    <div><span>{{ 'attendanceAttemptsCatalog.fields.source' | translate }}</span><strong class="attendance-attempt-value-pill attendance-attempt-value-pill--neutral">{{ attempt.sourceLabel }}</strong></div>
                    <div><span>Fecha</span><strong>{{ eventDateLabel }}</strong></div>
                    <div><span>Hora</span><strong>{{ eventTimeLabel }}</strong></div>
                    <div><span>{{ 'attendanceAttemptsCatalog.fields.timezone' | translate }}</span><strong>{{ attempt.timezone }}</strong></div>
                    <div><span>{{ 'attendanceAttemptsCatalog.fields.isActive' | translate }}</span><strong class="attendance-attempt-active"><i></i>{{ attempt.activeLabel }}</strong></div>
                    @if (hasFaceValidation) {
                    <div><span>{{ 'attendanceAttemptsCatalog.fields.faceValidationStatus' | translate }}</span><strong>{{ attempt.faceValidationStatusLabel }}</strong></div>
                    }
                  </div>
                </section>

                <section class="attendance-attempt-card attendance-attempt-processing-card">
                  <div class="attendance-attempt-card-heading attendance-attempt-card-heading--warning"><mat-icon>warning</mat-icon><div><h4>Resultado del procesamiento</h4><p>Motivo por el que este intento no generó un marcaje.</p></div></div>
                  <div class="attendance-attempt-reason-banner"><div class="attendance-attempt-warning-icon attendance-attempt-warning-icon--small"><mat-icon>priority_high</mat-icon></div><div><strong>{{ attempt.reasonCodeLabel }}</strong><p>{{ reasonDescription }}</p></div></div>
                  <div class="attendance-attempt-code"><mat-icon>info_outline</mat-icon><div><span>Código técnico</span><strong>{{ reasonTechnicalCode }}</strong></div></div>
                  <div class="attendance-attempt-device">
                    <div class="attendance-attempt-device__heading"><mat-icon>desktop_windows</mat-icon><div><strong>Dispositivo</strong><span>Información del dispositivo que envió el evento.</span></div></div>
                    <div class="attendance-attempt-device__values"><div><span>{{ 'attendanceAttemptsCatalog.fields.deviceId' | translate }}</span><strong>{{ attempt.deviceId || '-' }}</strong></div><div><span>{{ 'attendanceAttemptsCatalog.fields.deviceVersion' | translate }}</span><strong>{{ attempt.deviceVersion || '-' }}</strong></div></div>
                  </div>
                </section>
              </div>

              @if (hasLocation) {
              <details class="attendance-attempt-location" (toggle)="onLocationToggle($event)">
                <summary><div class="attendance-attempt-card-heading"><mat-icon>location_on</mat-icon><div><h4>Ubicación del intento</h4><p>{{ attempt.lat }}, {{ attempt.lng }} · {{ attempt.accuracy ?? '-' }} m</p></div></div><mat-icon>expand_more</mat-icon></summary>
                <div class="attendance-attempt-map-shell"><div #attendanceAttemptMap class="attendance-attempt-map"></div></div>
              </details>
              }

              @if (hasRawPayload) {
              <details class="attendance-attempt-payload attendance-attempt-payload--redesigned">
                <summary><div class="attendance-attempt-card-heading"><mat-icon>code</mat-icon><div><h4>{{ 'attendanceAttemptsCatalog.fields.rawPayload' | translate }}</h4><p>Datos técnicos completos del evento recibido.</p></div></div><mat-icon>expand_more</mat-icon></summary>
                <pre>{{ attempt.rawPayload | json }}</pre>
              </details>
              }
            </div>
          } @else {
            <div class="attendance-attempt-empty">
              <mat-icon>fact_check</mat-icon>
              <h4>{{ 'attendanceAttemptsCatalog.emptyEditorTitle' | translate }}</h4>
              <p>{{ 'attendanceAttemptsCatalog.emptyEditorDescription' | translate }}</p>
            </div>
          }
        </div>
      </mat-card>

      @if (isLoading) {
        <app-loading-state class="attendance-attempt-loading" [message]="'attendanceAttemptsCatalog.loading' | translate" />
      }
    </div>
  </div>
</section>
